<mat-stepper orientation="vertical" linear #stepper [selectedIndex]="1">
  <mat-step>
    <ng-template matStepLabel>{{
      "workorder.employee-visits.date-step" | translate
    }}</ng-template>
    <label class="employee-visits-label">{{
      "workorder.employee-visits.date-start" | translate
    }}</label>
    <div class="calendar-container">
      <input
        class="calendar"
        matInput
        [ngxMatDatetimePicker]="startVisitDatepicker"
        [formControl]="startDateControl"
        (dateChange)="changeCalendarDate()"
        readonly
        [max]="maxStartDate"
      />
      <ngx-mat-datepicker-toggle
        class="calendar-icon"
        matSuffix
        [for]="startVisitDatepicker"
      >
      </ngx-mat-datepicker-toggle>
      <ngx-mat-datetime-picker #startVisitDatepicker [stepMinute]="15">
        <ngx-mat-datepicker-actions>
          <button mat-button ngxMatDatepickerCancel>
            {{ "workorder.employee-visits.cancel" | translate }}
          </button>
          <button mat-button class="calendar-apply" ngxMatDatepickerApply>
            {{ "workorder.employee-visits.apply" | translate }}
          </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
    </div>

    <label class="employee-visits-label">{{
      "workorder.employee-visits.date-end" | translate
    }}</label>
    <div class="calendar-container">
      <input
        class="calendar"
        matInput
        [ngxMatDatetimePicker]="endVisitDatepicker"
        [formControl]="endDateControl"
        (dateChange)="changeCalendarDate()"
        readonly
        [min]="startDateControl.value"
        [max]="maxEndDate"
      />
      <ngx-mat-datepicker-toggle
        class="calendar-icon"
        matSuffix
        [for]="endVisitDatepicker"
      >
      </ngx-mat-datepicker-toggle>
      <ngx-mat-datetime-picker #endVisitDatepicker [stepMinute]="15">
        <ngx-mat-datepicker-actions>
          <button mat-button ngxMatDatepickerCancel>
            {{ "workorder.employee-visits.cancel" | translate }}
          </button>
          <button mat-button class="calendar-apply" ngxMatDatepickerApply>
            {{ "workorder.employee-visits.apply" | translate }}
          </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
    </div>

    <div>
      <button mat-button matStepperPrevious>
        {{ "workorder.employee-visits.back" | translate }}
      </button>
      <button mat-button matStepperNext>
        {{ "workorder.employee-visits.next" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>
      {{ "workorder.employee-visits.resume-step" | translate }}</ng-template
    >
    <label class="employee-visits-label"
      ><b>
        {{ startDateControl.value | localizedDate : "d MMMM, y" }}
      </b></label
    >
    <ul>
      <li
        class="resume-container"
        tabindex="0"
        *ngFor="let selectedEmployee of employeeVisitsToEdit"
        [ngClass]="{ removedVisit: !selectedEmployee.removeVisit }"
      >
        <label>{{ selectedEmployee.employeeAbbreviatedName }}</label>
        <div class="time-selector">
          <input
            matInput
            type="time"
            [ngModel]="selectedEmployee.startDate | date : 'HH:mm'"
            (ngModelChange)="changeEmployeeStartTime($event, selectedEmployee)"
            step="900"
          />
          <span class="spacer"></span>
          <input
            matInput
            type="time"
            [ngModel]="selectedEmployee.endDate | date : 'HH:mm'"
            (ngModelChange)="changeEmployeeEndTime($event, selectedEmployee)"
            step="900"
          />
        </div>
        <button
          class="icon"
          mat-icon-button
          *ngIf="employeeVisitsToEdit.length > 0"
          (click)="removeEmployeeVisit(selectedEmployee)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </li>
    </ul>
    <p class="time-legend" *ngIf="visitEndsNextDay">
      {{ "workorder.employee-visits.visit-ends-next-day" | translate }}
    </p>
    <div>
      <button mat-button matStepperPrevious>
        {{ "workorder.employee-visits.back" | translate }}
      </button>
    </div>
  </mat-step>
</mat-stepper>
